import _sortBy from "lodash/sortBy";
import _mapValues from "lodash/mapValues";
import _isNil from "lodash/isNil";
// tslint:disable:jsdoc-format

import { GraphicalOutputPlaceholder } from '@datacamp/campus-integration';
import { utils } from '@datacamp/drag-and-drop-exercise-core';
import * as React from 'react';
import { sentry } from '../lib/sentry';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FormalizeExercise = _ref => {
  let {
    children,
    exercise
  } = _ref;
  const [orderEntity, setOrderEntity] = React.useState(null);
  React.useEffect(() => {
    if (_isNil(exercise)) {
      return;
    }
    const {
      initialGroupedItems,
      itemsSolution,
      scts,
      targets
    } = utils.formalizeExercise(exercise);
    let groupedItems = initialGroupedItems;
    if (_isNil(itemsSolution) || _isNil(scts) || _isNil(initialGroupedItems) || _isNil(targets)) {
      const error = new Error('One of the required fields is empty.');
      sentry.captureError(error, exercise);
      throw error;
    }
    if (undefined === 'true') {
      groupedItems = _mapValues(groupedItems, items => _sortBy(items, 'id'));
    }
    setOrderEntity({
      initialGroupedItems: groupedItems,
      itemsSolution,
      scts,
      targets
    });
  }, [exercise]);
  if (_isNil(exercise) || _isNil(orderEntity)) {
    return ___EmotionJSX(GraphicalOutputPlaceholder, null);
  }
  return children({
    exercise,
    orderEntity
  });
};
export default FormalizeExercise;